import { Flex } from 'antd';
import styled from 'styled-components';

export const GraphContainer = styled(Flex).attrs({
  vertical: true,
  gap: 24
})`
  width: 10px;
  padding: 24px 0;
  flex-grow: 1;

  @media (max-width: 768px) {
    width: 100%;
    padding: 16px 0 0;
  }
`;

export const GraphEmptyStateContainer = styled(Flex).attrs({ justify: 'center', align: 'center' })`
  flex-grow: 1;
`;
